/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  commentCorrList: [],
  generalSystemParameter: [],
  commentsLinkData: [],
  commentTabObj: {},
  saveOrUpdateMessage: '',
  deleteCommentMsg: '',
  saveOrUpdateMessageByCommonPoc: '',
  deleteCommentMsgByCommonPoc: '',
  CommentListData: [],
  createNewSeqComId: null,
  generateNewSeqId: null,
  disableUpdate:false
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_COMMENT_LIST_COMM:
      return { ...state, commentCorrList: action.commentCorrList };
    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    case actionTypes.DELETE_COMMENT:
      return { ...state, deleteCommentMsg: action.deleteCommentMsg };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER_COMM:
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    case actionTypes.COMMENT_TAB_DATA:
      return { ...state, commentTabObj: action.commentTabObj };
    case actionTypes.FETCH_GENERATE_SEQ_NUM:
      return { ...state, generateNewSeqId: action.generateNewSeqId };
    // common poc comment & correspondent

    case actionTypes.GET_LINK_TABLE_DATA:
      return { ...state, commentsLinkData: action.payload };
    case actionTypes.SAVE_OR_UPDATE_FOR_COMMON_POC:
      return {
        ...state,
        saveOrUpdateMessageByCommonPoc: action.saveOrUpdateMessageByCommonPoc,
      };
    case actionTypes.DELETE_COMMENT_FOR_COMMON_POC:
      return {
        ...state,
        deleteCommentMsgByCommonPoc: action.deleteCommentMsgByCommonPoc,
      };
    case actionTypes.GET_COMMENT_LIST_FOR_COMMON_POC:
      return { ...state, CommentListData: action.CommentListData };
    case actionTypes.CREATE_NEW_SEQ_NUM:
      return { ...state, createNewSeqComId: action.createNewSeqComId };
    case actionTypes.COMMENT_DATA:
      return { ...state, commentData: action.commentData };
    case actionTypes.DISABLE_UPDATE:
      return { ...state, disableUpdate: action.disableUpdate };
    default:
      return state;
  }
};

export default reducer;
